export default "__VITE_ASSET__eac89aba__"